package com.appsyde.shared.modules.auth.domain.usecase

import com.appsyde.shared.modules.auth.domain.model.DomainResult
import com.appsyde.shared.modules.auth.domain.repo.AuthRepository

class GetLoginUrlUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(forceConsent: Boolean = false): DomainResult<String> =
        authRepository.getLoginUrl(forceConsent)
}
